import clsx from 'clsx';

export function getOptionClasses(active: boolean): string {
	return clsx(`lookup-option py-2 pl-5 text-left cursor-pointer`, active ? 'is-active' : '');
}
